import { trace, context } from '@opentelemetry/api';

export const useTracing = () => {
    const tracer = trace.getTracer('aurora-frontend');

    const trackUserAction = (actionName: string, metadata: Record<string, any> = {}) => {
        const span = tracer.startSpan(actionName);
        Object.entries(metadata).forEach(([key, value]) => {
            span.setAttribute(key, value);
        });
        span.end();
    };

    const trackApiCall = async <T>(
        name: string,
        fn: () => Promise<T>,
        metadata: Record<string, any> = {}
    ): Promise<T> => {
        const span = tracer.startSpan(`API_CALL_${name}`);
        Object.entries(metadata).forEach(([key, value]) => {
            span.setAttribute(key, value);
        });

        try {
            const result = await context.with(
                trace.setSpan(context.active(), span),
                fn
            );
            span.setStatus({ code: 0 }); // Success
            return result;
        } catch (error: any) {
            span.setStatus({ code: 1, message: error.message }); // Error
            throw error;
        } finally {
            span.end();
        }
    };

    return { trackUserAction, trackApiCall };
};